import { render, staticRenderFns } from "./CarbonEmissions.vue?vue&type=template&id=3b21a244&scoped=true&v-if=carbonEmissions%20%26%26%20carbonEmissionsComparisons"
import script from "./CarbonEmissions.vue?vue&type=script&setup=true&lang=ts"
export * from "./CarbonEmissions.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CarbonEmissions.vue?vue&type=style&index=0&id=3b21a244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b21a244",
  null
  
)

export default component.exports